import React from 'react'

import { CircularProgress, InputAdornment, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'

import useFetch from 'hooks/useFetch'
import { Controller, useFormContext } from 'react-hook-form'

import * as service from 'service'

const DepartmentForm = () => {
  const { response, isLoading } = useFetch(
    service.dponet.departments.getAll,
    {
      perPage: 1000,
      active: true,
      order: 'departments.name ASC',
    },
    [],
  )

  const departments = response?.data?.departments

  const { control, errors } = useFormContext()

  return (
    <Controller
      control={control}
      name="departments"
      mode="onChange"
      onChange={([, data]) => data}
      as={
        <Autocomplete
          multiple
          options={departments ?? []}
          getOptionLabel={(option) => option.name}
          getOptionSelected={(option, value) =>
            option.id === value.id || value.id === 0
          }
          disabled={isLoading}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Departamento"
              error={!!errors?.departments}
              helperText={<>{errors?.departments?.message}</>}
              disabled={isLoading}
              InputProps={{
                ...(isLoading
                  ? {
                      endAdornment: (
                        <InputAdornment position="end">
                          <CircularProgress size={22} />
                        </InputAdornment>
                      ),
                    }
                  : { ...params.InputProps }),
              }}
              fullWidth
            />
          )}
        />
      }
    />
  )
}

export default DepartmentForm
